import React from "react";
import ReactDOM from "react-dom";
import { Trail, Keyframes, animated, config } from "react-spring/renderprops";
import "./App.css";

const defaultStyles = {
  overflow: "hidden",
  width: "100%",
  color: "black",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "32px",
  fontFamily: "Roboto, sans-serif",
  textTransform: "uppercase",
  border: "2px solid black",
};

export default class Box extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      items: [this.props.word],
      delay: this.props.index * this.props.delay,
      duration: this.props.duration,
      ref: React.createRef(),
    };
    this.clickTest = this.clickTest.bind(this);
    this.destroy = this.destroy.bind(this);
    this.get_position = this.get_position.bind(this);
  }

  clickTest(word) {
    console.log(word);
  }

  destroy() {
    this.setState({ items: [] });
    this.setState({ delay: 200000 });
  }

  get_position() {
    let elem = document.getElementById("word");
    return elem.style.top;
  }

  // componentDidMount() {
  //   setTimeout(() => {
  //     this.setActive();
  //   }, this.state.delay + 2500);
  // }

  render() {
    var Content = Keyframes.Spring(async (next) => {
      // None of this will cause React to render, the component renders only once :-)
      await next({
        from: {
          opacity: 0,
          width: "auto",
          padding: "2%",
          left: "-50%",
          borderRadius: "19px",
          opacity: 1,
          top: "-30%",
          background: "white",
          textAlign: "center",
          zIndex: 50,
        },
      });
      await next({
        from: { left: "0%" },
        top: "100%",
        // background: "seagreen",
        config: { duration: this.state.duration, delay: this.state.delay },
      });
    });
    let word = this.state.items[0];
    if (word !== undefined) {
      word = word.replace("_", " ");
    }
    return (
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: "0%",
          bottom: "0%",
        }}
      >
        <Content native>
          {(props) => (
            <animated.div
              id="word"
              style={{ position: "relative", ...defaultStyles, ...props }}
            >
              <span
                onClick={() => this.clickTest(word)}
                translate="no"
                style={{ padding: "10px" }}
              >
                <strong>{word}</strong>
              </span>
            </animated.div>
          )}
        </Content>
      </div>
    );
  }
}
